import React from "react";
import { AddCompanyDialog } from "@/components/companies/AddCompanyDialog";
import { Company } from "@/types";

interface CompanyHeaderProps {
  onCompanyAdded: (company: Company) => void;
}

export const CompanyHeader = ({ onCompanyAdded }: CompanyHeaderProps) => {
  return (
    <div className="flex justify-between">
      <div>
        <p className="text-muted-foreground">
          Create and manage companies using ShiftSage
        </p>
      </div>
      
      <AddCompanyDialog onCompanyAdded={onCompanyAdded} />
    </div>
  );
};
